import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-error',
  templateUrl: './payment-error.page.html',
  styleUrls: ['./payment-error.page.scss'],
})
export class PaymentErrorPage { }
